export default __webpack_public_path__ + "static/media/suplias-go-logo.cc546b34.svg";